// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"SY-z","sponsoredTooltipWrapper":"TY-z","sponsoredTooltip":"UY-z","newCard":"VY-z"};